import * as Converter from "./converter";

import type * as Repository from "../../_repository";

type Props = {
	optionPmsColorListQueryData: Repository.Query.QueryData.OptionPmsColorListQueryData;
};

export const useViewData = ({ optionPmsColorListQueryData }: Props) => {
	/**
	 * ViewData への変換
	 */
	const { viewData } = Converter.useViewDataConverter({ optionPmsColorListQueryData });

	return {
		viewData,
	};
};
